// extracted by mini-css-extract-plugin
export var activeDot = "_3h-c";
export var buttonContainer = "_3h-9";
export var channelButton = "_3h-a";
export var clickable = "_3h-d";
export var content = "_3h-0";
export var contentFull = "_3h-2";
export var contentThird = "_3h-1";
export var contentWrapper = "_3h-7";
export var description = "_3h-5";
export var heightShort = "_3h-f";
export var image = "_3h-3";
export var imageContainer = "_3h-4";
export var selectButton = "_3h-e";
export var spinnerContainer = "_3h-b";
export var titleContent = "_3h-8";
export var titleWrapper = "_3h-6";